'use client'

import clsx from 'clsx'
import { useTranslations } from 'next-intl'

import { IReferenceGroup } from '@/_types'

import { ZReferencesSwiper } from './components'

export default function ZReferencesGroup({
	referenceGroup,
	className
}: {
	referenceGroup: IReferenceGroup
	className?: string
}) {
	const t = useTranslations('components.zReferences')

	return (
		<section id='referencie' className={clsx('bg_move2 pdt-60 pdb-60 pdb-60lg ', className)}>
			<div className='wrapper'>
				<div className='section_head'>
					<h2 className='title_side text_uc'>{t('sectionName')}</h2>
				</div>
			</div>

			<ZReferencesSwiper references={referenceGroup.references} />

			<div className='wrapper show_lgm mgt-30 pos_rel'>
				<div className='slider-custom-scrollbar-cont'>
					<div className='slider-custom-scrollbar light'></div>
				</div>
				<div className='swiper_controls_side mgt-20'>
					<button
						className='btn_circle toleft references-prev'
						type='button'
						name='predchádzajúci'
						title='Predchádzajúci'
					>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar2_l' />
							</svg>
						</span>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar2_l' />
							</svg>
						</span>
					</button>

					<button
						className='btn_circle references-next'
						type='button'
						name='následujúci'
						title='Následujúci'
					>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar2_r' />
							</svg>
						</span>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar2_r' />
							</svg>
						</span>
					</button>
				</div>
			</div>
		</section>
	)
}
